import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import mixpanelService from "./mixpanelService";
import mixpanelEvents, { getScreenName } from "../../config/mixpanelEvents";
import { getTrafficSourceInfo, getPageTypeForExport } from "./trafficSource";

declare var mixpanel: any;

const MixpanelPageTracker = () => {
  const location = useLocation();
  const lastPathnameRef = useRef<string>("");
  const trafficSourceRef = useRef<any>(null);
  const superPropsRegisteredRef = useRef<boolean>(false);
  const firstLandingPageRef = useRef<string>("");

  useEffect(() => {
    if (superPropsRegisteredRef.current) return;
    superPropsRegisteredRef.current = true;

    try {
      const trafficInfo = getTrafficSourceInfo(location.pathname);
      trafficSourceRef.current = trafficInfo;

      const firstLandingPage = window.location.origin + location.pathname + location.search;
      firstLandingPageRef.current = firstLandingPage;

      if (typeof mixpanel !== "undefined") {
        mixpanel.register({
          channel: "website",
          ...(trafficInfo?.referrer_domain ? { referrer_domain: trafficInfo.referrer_domain } : {}),
          user_status: trafficInfo.user_type,
        });

        if (!sessionStorage.getItem("mp_session_tracked")) {
          sessionStorage.setItem("mp_session_tracked", "true");
          mixpanel.people.set({
            channel: "website",
            ...(trafficInfo?.referrer_domain ? { referrer_domain: trafficInfo.referrer_domain } : {}),
            user_status: trafficInfo.user_type,
          });
        }
      }
    } catch (e) {
      console.error("mixpanel super props registration failed", e);
    }
  }, []);

  useEffect(() => {
    try {
      if (location.pathname === lastPathnameRef.current) return;
      lastPathnameRef.current = location.pathname;

      const trafficInfo = trafficSourceRef.current || getTrafficSourceInfo(location.pathname);

      const screen_name = getScreenName(location.pathname);
      if (!screen_name) return;

      const currentUrl = window.location.origin + location.pathname + location.search;

      const referrerDomain = trafficInfo?.referrer_domain || null;

      mixpanelService({
        event: mixpanelEvents.SCREEN_LOAD,
        screen_name,
        page_path: location.pathname,
        page_category: getPageTypeForExport(location.pathname),
        page_url: currentUrl,
        landing_page: firstLandingPageRef.current,
        ...(referrerDomain ? { referrer_domain: referrerDomain } : {}),
      });
    } catch (e) {
      console.error("mixpanel screen_load failed", e);
    }
  }, [location.pathname]);

  return null;
};

export default MixpanelPageTracker;
